<template>
    <div v-if="userType === 2 || userType === 3 || userType === 5">
        <NavigationTeacherAndParent />
    </div>
    <div v-else-if="userType === 4">
        <NavigationPetugas />
    </div>
</template>


<script setup>
import { useMainStore } from '@/store'
import { computed, ref, onMounted } from 'vue'
import NavigationPetugas from './NavigationPetugas.vue'
import NavigationTeacherAndParent from './NavigationTeacherAndParent.vue'



const store = useMainStore()
const user = computed(() => store.user)
const userType = computed(() => user.value?.type)

const userReady = ref(false)

onMounted(() => {
    const interval = setInterval(() => {
        if (user.value && user.value.type !== undefined) {
            userReady.value = true
            clearInterval(interval)
        }
    }, 100)
})
</script>
